import {RootState} from '../rootReducer';

export const visualizationSelector = (state: RootState) => state.visualization;
